<script>
import Loader from "@/components/widgets/loader";
import Swal from "sweetalert2";
import Layout from '../../../layouts/main'
import PageHeader from '@/components/page-header'

import appConfig from "@/app.config";

import {getAliasList, getExchangeList, getExchangeBalance, getExchangeTransferList, transfer, binanceLoan} from '@/api/user'

/**
 * Products-order component
 */
export default {
   page: {
    title: "转账",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader},
  props: {
    updating: {
      type: Boolean,
    },
  },
  data() {
    return {
      title: '转账',
      alias: '',
      out_exchange_list: [],
      in_exchagne_list: [],
      alias_list: [],
      coin_list: [],
      transfer_out_exchange: '',
      transfer_in_exchange: '',
      transfer_coin: '',
      transfer_amount: 0,
      transfer_passwd: '',

      loan_alias: '',
      loan_amount: 0,
      loan_passwd: '',
      type_list: ["借款", "还款"]
    }
  },
  mounted() {
    this.get_alias_list()
  },
  methods: {
    get_alias_list() {
      let promise = getAliasList(); return promise.then(res => {
          this.alias_list = res
          console.log(this.alias_list)
      }).catch(error => {
          console.log(error)
      })
      },
    chooseAlias(){
        this.out_exchange_list = []
        this.in_exchagne_list = []
        this.coin_list = []
        this.transfer_out_exchange = ""
        this.transfer_in_exchange = ""
        this.transfer_coin = ""
        this.transfer_amount = 0
        let promise = getExchangeList(this.alias); return promise.then(res => {
            this.out_exchange_list = res
            console.log(this.out_exchange_list)
        }).catch(error => {
            console.log(error)
    })
    },
    chooseExchange(){
        this.in_exchagne_list = []
        this.coin_list = []
        this.transfer_in_exchange = ""
        this.transfer_coin = ""
        this.transfer_amount = 0
        getExchangeTransferList(this.alias, this.transfer_out_exchange).then(res => {
          console.log(res)
          this.in_exchagne_list= res
        }).catch(error => {
          console.log(error)
        })
        let promise = getExchangeBalance(this.alias, this.transfer_out_exchange); return promise.then(res => {
          for (let i = 0; i < res.length; ++i) {
            let c = res[i]["coin"] + "（" + String(res[i]["amount_free"]) + "）"
            this.coin_list.push(c)
          }
            console.log(this.coin_list)
            }).catch(error => {
                console.log(error)
        })
    },
    chooseCoin(){
        this.transfer_amount = 0
    },
    transfer_crypto(alias, transfer_out_exchange, transfer_in_exchange, transfer_coin, transfer_amount, transfer_passwd){
        let data = {
            "alias": alias,
            "pwd": transfer_passwd,
            "exchange_from": transfer_out_exchange,
            "exchange_to": transfer_in_exchange,
            "coin": transfer_coin,
            "amount": transfer_amount
        }
        let promise = transfer(data); return promise.then(res => {
            if (res["message"] == "请求成功"){
                this.pwd = ""
                Swal.fire({
                title: "转账成功！",
                text: res["message"],
                icon: "success",
                // background: "#222736"
                })
                window.location.reload()
            } else{
                Swal.fire({
                title: "转账失败！",
                text: res["message"],
                icon: "error",
                // background: "#222736"
                })
                this.showDeleteModal = false
                }
        }).catch(error => {
            console.log(error)
        })
    },
    chooseLoanAlias(){
      this.type = ""
      this.loan_amount = 0
    },
    chooseType(){
      this.loan_amount = 0
    },
    loan_usdt() {
      let data = {
            "alias": this.loan_alias,
            "pwd": this.loan_passwd,
            "type": this.type,
            "amount": this.loan_amount
        }
        let promise = binanceLoan(data); return promise.then(res => {
            if (res["message"] == "请求成功"){
                this.pwd = ""
                Swal.fire({
                title: "成功！",
                text: res["message"],
                icon: "success",
                // background: "#222736"
                })
                window.location.reload()
            } else{
                Swal.fire({
                title: "失败！",
                text: res["message"],
                icon: "error",
                // background: "#222736"
                })
                this.showDeleteModal = false
                }
        }).catch(error => {
            console.log(error)
        })
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
    />

    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
            转账
            </h4>

            <b-form>
              <b-form-group
                label="Alias"
                label-for="horizontal-firstname-input"
                label-cols-sm="3"
              >
                <b-form-select
                  :options="alias_list"
                  @change="chooseAlias"
                  type="text"
                  v-model="alias"
                />
              </b-form-group>

              <b-form-group
                label="转出交易所"
                label-for="horizontal-firstname-input"
                label-cols-sm="3"
              >
                <b-form-select
                  id="out-exchange"
                  :options="out_exchange_list"
                  @change="chooseExchange"
                  type="text"
                  v-model="transfer_out_exchange"
                />
              </b-form-group>

              <b-form-group
                class="mb-4"
                label="转账品种"
                label-for="horizontal-password-input"
                label-cols-sm="3"
              >
                <b-form-select
                  id="transfer-symbol"
                  :options="coin_list"
                  @change="chooseCoin"
                  type="text"
                  v-model="transfer_coin"
                />
              </b-form-group>

              <b-form-group
                label="转入交易所"
                label-for="horizontal-firstname-input"
                label-cols-sm="3"
              >
                <b-form-select
                  id="in-exchange"
                  :options="in_exchagne_list"
                  type="text"
                  v-model="transfer_in_exchange"
                />
              </b-form-group>

              <b-form-group
                class="mb-4"
                label="转账数量"
                label-for="horizontal-input"
                label-cols-sm="3"
              >
                <b-form-input
                  id="transfer-amount"
                  type="number"
                  v-model="transfer_amount"
                />
              </b-form-group>

              <b-form-group
                class="mb-4"
                label="密码"
                label-for="horizontal-password-input"
                label-cols-sm="3"
              >
                <b-form-input
                  id="transfer-password"
                  type="password"
                  v-model="transfer_passwd"
                />
              </b-form-group>

              <div class="form-group row justify-content-end">
                <div class="col-sm-9">
                  <div>
                    <b-button variant="primary" @click="transfer_crypto(alias, transfer_out_exchange, transfer_in_exchange, transfer_coin, transfer_amount, transfer_passwd)">
                      确定
                    </b-button>
                  </div>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>



    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
            币安杠杠借贷（USDT）
            </h4>

            <b-form>
              <b-form-group
                label="Alias"
                label-for="horizontal-firstname-input"
                label-cols-sm="3"
              >
                <b-form-select
                  :options="alias_list"
                  @change="chooseLoanAlias"
                  type="text"
                  v-model="loan_alias"
                />
              </b-form-group>

              <b-form-group
                label="选项"
                label-for="horizontal-firstname-input"
                label-cols-sm="3"
              >
                <b-form-select
                  :options="type_list"
                  @change="chooseType"
                  type="text"
                  v-model="type"
                />
              </b-form-group>

              <b-form-group
                class="mb-4"
                label="数量"
                label-for="horizontal-password-input"
                label-cols-sm="3"
              >
                <b-form-input
                  id="loan-amount"
                  type="number"
                  v-model="loan_amount"
                />
              </b-form-group>

              <b-form-group
                class="mb-4"
                label="密码"
                label-for="horizontal-password-input"
                label-cols-sm="3"
              >
                <b-form-input
                  id="loan-password"
                  type="password"
                  v-model="loan_passwd"
                />
              </b-form-group>

              <div class="form-group row justify-content-end">
                <div class="col-sm-9">
                  <div>
                    <b-button variant="primary" @click="loan_usdt()">
                      确定
                    </b-button>
                  </div>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>

    <!-- end row -->
  </Layout>
</template>
